// This file uses commonJS exports because it's referenced in our webpack build
"use strict";

const toVarName = require("./var-name.js");

// Map of dependency names to a function which imports the actual value
// ************ WARNING ***************
// Adding dependencies to this list which are used by a component which already exists
// is a BREAKING CHANGE, and WILL break any consumers of the component until they update their
// version of the NPM module!
// This list is intended for components which must have a single instance on a page
// (ns-util, Vue, vuetify) or are both very large and are likely already included
// in consuming applications (axios, ns-icon).
const allDeps = {
  vue: () => require("vue"),
  "@nuskin/ns-util": () => require("@nuskin/ns-util"),
  vuetify: () => require("vuetify/lib"),
  "vuetify/lib": () => require("vuetify/lib"),
  axios: () => require("axios"),
  "@nuskin/ns-icon": () => require("@nuskin/ns-icon"),
  "@nuskin/design-components": () => require("@nuskin/design-components"),
};

/**
 * Sets up the global variables for the externalized dependencies.
 * @param {Window} globalThis window on which to expose the dependency globals
 */
function setDependencyGlobals(globalThis = window) {
  Object.entries(allDeps).forEach(([name, importer]) => {
    const varname = asVarName(name);
    if (!Object.prototype.hasOwnProperty.call(globalThis, varname)) {
      globalThis[varname] = importer();
    }
  });
}

/**
 * Mapping between dependency names and global variable names
 * @constant {Object.<string, string>}
 */
const externalDependencyGlobals = Object.keys(allDeps).reduce(
  (result, name) => Object.assign(result, { [name]: asVarName(name) }),
  {}
);

module.exports = {
  externalDependencyGlobals,
  setDependencyGlobals,
};

function asVarName(name) {
  return `__ns_account_components__deps__${toVarName(name)}__`;
}
